import {
  SetProperty,
  DownloadTransferListPagesInvoicesPayload,
  DownloadTransfersListsInvoicesPayload,
  GetTransfersListsPayload,
  IssueTransferListPagesInvoicesPayload,
  IssueTransfersListsInvoicesPayload,
  PageCageDetails,
  ReceiveItem,
  ReceiveStartPayload,
  RemoveTransferListPagePayload,
  RemoveTransferListPayload,
  TransferPageCageIssueOrDownloadPayload,
  TransferReceiveValidateBadgePayload,
  TransfersState,
  ReceiveBatchesMovementPayload,
  ReceiveUnfitMovementPayload,
  ValidateProductBarcodePayload,
  ValidateMovementAddressPayload,
  ReceiveDataStatus,
  GetReceiveStatusPayload,
  ChangeCageFcPayload,
  ReceiveValidateSupervisorBadgePayload,
  ReceiveSupervisorCountBatchesPayload,
  ReceiveSupervisorProductNotFoundPayload,
  SearchTransferCagesByFiltersPayload,
} from './TransfersTypes'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { cloneDeep } from 'lodash'
import { justForSideEffectWithPayload, justForSideEffect } from 'src/infrastructure/saga.helpers'

export const initialState: TransfersState = {
  filtersSearchLists: {
    fcs: [],
    status: [],
    priorities: [],
  },
  lastGetTransfersListsPayload: {
    idSourceFc: undefined,
    idDestinationFc: undefined,
    createdDate: undefined,
    shippingDate: undefined,
    priorities: [],
    idsStatus: [],
  },
  transfersLists: [],
  selectedTransfersLists: [],
  tableTransfersListsPagination: {
    currentPage: 1,
    perPage: 10,
    totalItems: 0,
    totalPages: 0,
    order: undefined,
    orderBy: undefined,
  },
  transferListPages: [],
  transferPageDetails: undefined,
  receiveUser: undefined,
  receiveData: undefined,
  receiveSupervisor: undefined,
  cageAddressInfo: undefined,
  transferCages: [],
  transferCageDetails: undefined,
}

const getSearchFilters = justForSideEffect()
const getTransfersLists = justForSideEffectWithPayload<GetTransfersListsPayload>()
const removeTransferList = justForSideEffectWithPayload<RemoveTransferListPayload>()
const downloadTransfersListsInvoices = justForSideEffectWithPayload<DownloadTransfersListsInvoicesPayload>()
const issueTransfersListsInvoices = justForSideEffectWithPayload<IssueTransfersListsInvoicesPayload>()
const getTransferListPages = justForSideEffectWithPayload<number>()
const removeTransferListPage = justForSideEffectWithPayload<RemoveTransferListPagePayload>()
const downloadTransferListPagesInvoices = justForSideEffectWithPayload<DownloadTransferListPagesInvoicesPayload>()
const issueTransferListPagesInvoices = justForSideEffectWithPayload<IssueTransferListPagesInvoicesPayload>()
const getTranferPageDetails = justForSideEffectWithPayload<number>()
const issueTransferListPageCageInvoice = justForSideEffectWithPayload<TransferPageCageIssueOrDownloadPayload>()
const downloadTransferListPageCageInvoice = justForSideEffectWithPayload<TransferPageCageIssueOrDownloadPayload>()
const receiveValidateBadge = justForSideEffectWithPayload<TransferReceiveValidateBadgePayload>()
const receiveStart = justForSideEffectWithPayload<ReceiveStartPayload>()
const getReceiveStatus = justForSideEffectWithPayload<GetReceiveStatusPayload>()
const validateProductBarcode = justForSideEffectWithPayload<ValidateProductBarcodePayload>()
const validateMovementAddress = justForSideEffectWithPayload<ValidateMovementAddressPayload>()
const receiveValidateSupervisorBadge = justForSideEffectWithPayload<ReceiveValidateSupervisorBadgePayload>()
const receiveSupervisorProductNotFound = justForSideEffectWithPayload<ReceiveSupervisorProductNotFoundPayload>()
const receiveSupervisorCountBatches = justForSideEffectWithPayload<ReceiveSupervisorCountBatchesPayload>()
const receiveMovement = justForSideEffectWithPayload<ReceiveBatchesMovementPayload>()
const receiveUnfitMovement = justForSideEffectWithPayload<ReceiveUnfitMovementPayload>()
const getCageAddressInfo = justForSideEffectWithPayload<string>()
const changeCageFc = justForSideEffectWithPayload<ChangeCageFcPayload>()
const searchCagesByFilters = justForSideEffectWithPayload<SearchTransferCagesByFiltersPayload>()
const getCageDetails = justForSideEffectWithPayload<number>()

const updateCageDetails = (state: TransfersState, action: PayloadAction<PageCageDetails>): TransfersState => {
  const cageDetails = action.payload

  const cloneState = cloneDeep(state.transferPageDetails)

  if (!cloneState) {
    return state
  }

  const currentCageIndex = cloneState.cages.findIndex((cage) => cage.idCage === cageDetails.idCage)

  if (currentCageIndex === -1) {
    cloneState.cages.push(cageDetails)
  } else {
    cloneState.cages[currentCageIndex] = {
      ...cloneState.cages[currentCageIndex],
      ...cageDetails,
    }
  }

  return {
    ...state,
    transferPageDetails: cloneState,
  }
}

const updateReceiveDataStatus = (state: TransfersState, action: PayloadAction<ReceiveDataStatus>): TransfersState => {
  const receiveDataStatus = action.payload

  const cloneState = cloneDeep(state.receiveData)

  if (!cloneState) {
    return state
  }

  cloneState.idStatus = receiveDataStatus.idStatus
  cloneState.status = receiveDataStatus.status

  return {
    ...state,
    receiveData: cloneState,
  }
}

const setCurrentReceiveItem = (state: TransfersState, action: PayloadAction<ReceiveItem | undefined>): TransfersState => {
  const item = action.payload

  const cloneState = cloneDeep(state.receiveData)

  if (!cloneState) {
    return state
  }

  cloneState.currentItem = item

  return {
    ...state,
    receiveData: cloneState,
  }
}

const updateReceiveDataItems = (state: TransfersState, action: PayloadAction<ReceiveItem[]>): TransfersState => {
  const items = action.payload
  const cloneState = cloneDeep(state.receiveData)

  if (!cloneState) {
    return state
  }

  cloneState.items = items

  return {
    ...state,
    receiveData: cloneState,
  }
}

const setCurrentItemAsDone = (state: TransfersState, action: PayloadAction<ReceiveItem>): TransfersState => {
  const item = action.payload

  const cloneState = cloneDeep(state.receiveData)

  if (!cloneState) {
    return state
  }

  const currentItemIndex = cloneState.items.findIndex((i) => i.idModel === item.idModel && i.order === item.order)

  if (currentItemIndex !== -1) {
    cloneState.items[currentItemIndex].done = true
  }

  return {
    ...state,
    receiveData: cloneState,
  }
}

const setProperty = (state: TransfersState, action: PayloadAction<SetProperty>): TransfersState => {
  const { property, value } = action.payload

  return {
    ...state,
    [property]: value,
  }
}

const clearState = (): TransfersState => initialState

const clearProperty = (
  state: TransfersState,
  action: PayloadAction<string | string[]>,
): TransfersState => {
  const newState = cloneDeep(state)

  if (Array.isArray(action.payload)) {
    action.payload.forEach((property) => {
      newState[property] = initialState[property]
    })
  } else {
    newState[action.payload] = initialState[action.payload]
  }

  return newState
}

const slice = createSlice({
  name: 'transfers',
  initialState,
  reducers: {
    getSearchFilters,
    getTransfersLists,
    removeTransferList,
    downloadTransfersListsInvoices,
    issueTransfersListsInvoices,
    getTransferListPages,
    removeTransferListPage,
    downloadTransferListPagesInvoices,
    issueTransferListPagesInvoices,
    getTranferPageDetails,
    issueTransferListPageCageInvoice,
    downloadTransferListPageCageInvoice,
    receiveValidateBadge,
    receiveStart,
    getReceiveStatus,
    validateProductBarcode,
    validateMovementAddress,
    receiveValidateSupervisorBadge,
    receiveSupervisorProductNotFound,
    receiveSupervisorCountBatches,
    receiveMovement,
    receiveUnfitMovement,
    getCageAddressInfo,
    changeCageFc,
    searchCagesByFilters,
    getCageDetails,
    updateCageDetails,
    updateReceiveDataStatus,
    setCurrentReceiveItem,
    updateReceiveDataItems,
    setCurrentItemAsDone,
    setProperty,
    clearState,
    clearProperty,
  },
})

export default slice.reducer

export const { actions } = slice
